import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text2 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {noKadestritDivide, noKadestritDivideText} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(noKadestritDivideText) && Boolean(noKadestritDivide) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          {getBreakLinesTextShumaType3(noKadestritDivideText)}
        </div>
      )}
    </div>
  );
});

export default Section8Text2;
